export default "__VITE_ASSET__ff3b0d4b__"